module.exports = __webpack_public_path__ + "static/media/img-reason-deal@3x.5aae9a15.png";